// @ts-nocheck
export const JOIN_GROUP_CHAT = "join_group_chat";
export const ON_NEW_GROUP_CHAT = "new_group_chat";
export const ON_EDIT_GROUP_CHAT = "edit_group_chat";
export const NEW_GROUP_MESSAGE_EMIT = "new_group_message";
export const NEW_GROUP_MESSAGE_LISTEN = "new_group_message";
export const ON_ADDED_TO_GROUP_CHAT = "added_to_group_chat";
export const ON_REMOVED_FROM_GROUP_CHAT = "removed_from_group_chat";
export const UPDATE_CHAT_STATUS = "update_chat_status";
export const UPDATE_GROUP_MSG_STATUS = "update_group_msg_status";
export const SETUP = "setup";
export const HEARTBEAT = "register_device";
export const MESSAGE_DELIVERED = "message_delivered";
export const GROUP_MESSAGE_DELIVERED = "group_message_delivered";
export const SET_USER_STATE = "SET_USER_STATE";
export const GET_UNREAD_MESSAGES = "get_unread_messages";